import React from 'react';
import { AppBar, Toolbar, Box, Typography } from '@mui/material';

function Footer({ isLandingPage }) {
  return (
    <AppBar
      position={isLandingPage ? 'absolute' : 'relative' }
      sx={{
        backgroundColor: isLandingPage ? 'rgba(218, 210, 210, 0.85)' : '#ffffff',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        zIndex: isLandingPage ? 1 : 10,
        height: '110px',
        top: 'auto', // Ensure it stays at the bottom
        bottom: 0,
        width: '100%',
      }}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          px: 2,
        }}
      >
        
        <Box>
          <Typography
            sx={{
              fontSize: '1rem',
              fontFamily: 'General Sans, sans-serif',
              color: '#4b6043',
              textAlign: 'center',
            }}
          >
            © 2025 FitEstate Project. All rights reserved.
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Footer;